"use client";

import React, { useState } from "react";
import { FaPhone, FaComments } from "react-icons/fa";
import ContactPopup from "./ContactPopup";
import Link from "next/link";
import { FaEnvelope, FaWhatsapp, FaTimes } from "react-icons/fa";
import { site, trackContact, whatsappHref } from "../../lib/site";

export interface DefaultContactButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children?: React.ReactNode;
}

export function DefaultContactButton({ className = "", children, ...buttonProps }: DefaultContactButtonProps) {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <button type="button" aria-label={children ? undefined : "Contact LITPL"} onClick={() => setIsContactOpen(true)} className={`${className}`} {...buttonProps}>
        {children || <FaPhone className="h-6" />}
      </button>
      <ContactPopup isOpen={isContactOpen} setIsOpen={setIsContactOpen} />
    </>
  );
}

export function FixedContactButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-40 hidden lg:block">
      {/* Contact options */}
      <div aria-hidden={!isOpen} className={`${isOpen ? "scale-100 opacity-100" : "scale-0 opacity-0"} absolute bottom-16 right-0 mb-2 flex flex-col gap-3 transition-all duration-300 origin-bottom-right`}>
        <Link tabIndex={isOpen ? 0 : -1} href={`tel:${site.phoneTel}`} onClick={() => trackContact("call")} className="bg-green-600 text-white rounded-full p-3 shadow-lg hover:bg-green-700 transition-colors flex items-center justify-center" title="Call Us">
          <FaPhone className="text-xl" />
        </Link>

        <Link tabIndex={isOpen ? 0 : -1} href={`mailto:${site.email}`} onClick={() => trackContact("email")} className="bg-blue-600 text-white rounded-full p-3 shadow-lg hover:bg-blue-700 transition-colors flex items-center justify-center" title="Email Us">
          <FaEnvelope className="text-xl" />
        </Link>

        <Link tabIndex={isOpen ? 0 : -1} href={whatsappHref("Hello LITPL, I want to discuss a business requirement.")} onClick={() => trackContact("whatsapp")} target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white rounded-full p-3 shadow-lg hover:bg-green-600 transition-colors flex items-center justify-center" title="WhatsApp">
          <FaWhatsapp className="text-xl" />
        </Link>
      </div>

      {/* Main button */}
      <button type="button" aria-expanded={isOpen} onClick={() => setIsOpen(!isOpen)} className={`${isOpen ? "bg-red-500 hover:bg-red-600" : "bg-brand-700 hover:bg-brand-900"} text-white rounded-full w-14 h-14 shadow-lg flex items-center justify-center transition-colors`} aria-label={isOpen ? "Close contact options" : "Open contact options"}>
        {isOpen ? <FaTimes className="text-2xl" /> : <FaComments className="text-2xl" />}
      </button>
    </div>
  );
}
